import { FC, useCallback, useEffect } from 'react';

import useBaseHead from '../hooks/useBaseHead';
import useAppStyles from '../providers/Styles/hooks';

type BaseHeadType = {};

const BaseHead: FC<BaseHeadType> = () => {
	const styles = useAppStyles();
	useBaseHead();

	const handleFonts = useCallback(() => {
		if (!styles?.googleFontName) return;
		const link = document.createElement('link');
		link.rel = 'stylesheet';
		link.href = `https://fonts.googleapis.com/css2?family=${styles.googleFontName.replace(
			/ /g,
			'+'
		)}:wght@100;200;300;400;500;600;700&display=swap`;
		document.head.appendChild(link);
	}, [styles]);

	const handleAddRootStyles = useCallback(() => {
		if (!styles) return;
		const styleTag = document.createElement('style');
		styleTag.innerHTML = `:root {
				--primary-color: ${styles.primaryColor ?? '#eb7353'};
				--primary-color-a25: ${styles.primaryColor ?? '#eb7353'}25;
				--secondary-font-color: ${styles.fontColor ?? 'var(--theme-colors-100)'};
				--primary-background: ${styles.bgColor ?? 'var(--theme-colors-100)'};
				--font-family: ${styles.fontName ? `"${styles.fontName}", ` : ''}
						${styles.googleFontName ? `"${styles.googleFontName}", ` : ''}
						'Proxima Nova',
					-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu,
					Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
			}`;
		document.head.appendChild(styleTag);
	}, [styles]);

	useEffect(() => {
		handleFonts();
		handleAddRootStyles();
	}, []);

	return null;
};

export default BaseHead;
